import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { ProfileDetails } from 'src/app/components/interfaces/myStories.interface';
import { EventInfo } from 'src/app/interfaces/event-info.interface';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MyStoriesService {

  private _participantInfo: EventInfo = <any>null;

  constructor(private _httpClient: HttpClient) { }

  public set particpantInfoResponse(data : EventInfo) {
    this._participantInfo = data;
  }

  public get particpantInfoResponse(): EventInfo {
    return this._participantInfo;
  }

  private editProfileClickedSubject = new BehaviorSubject<boolean>(false);
  private editProfileClosedSubject = new BehaviorSubject<boolean>(false);

  private _isProfileUpdated$ = new BehaviorSubject<boolean>(false);

  editProfileClicked$ = this.editProfileClickedSubject.asObservable();
  editProfileClosed$ = this.editProfileClosedSubject.asObservable();


  private showSpinnerSubject = new BehaviorSubject<boolean>(false);
  showSpinnerSubject$ = this.showSpinnerSubject.asObservable();

  showSpinner() {
    this.showSpinnerSubject.next(true);
  }

  hideSpinner() {
    this.showSpinnerSubject.next(false);
  }

  editProfilePopupVisible(visible: boolean) {
    this.editProfileClickedSubject.next(visible);
  }

  setIsProfileUpdate(isUpdated: boolean) {
    this._isProfileUpdated$.next(isUpdated)
  }

  getIsProfileUpdated(): Observable<boolean> {
    return this._isProfileUpdated$.asObservable()
  }

  editProfilePopupClosed() {
    this.editProfileClosedSubject.next(true);
  }

  getGarageDetails(ciamId?: any): Observable<any> {
    const headers = new HttpHeaders()
      .set('ciamId', ciamId)
      .set('Content-Type', 'application/json');
    let url = ''
    if (localStorage.getItem('isLoggedIn') === 'true') {
      url = environment.proxyEndpoint + '/stories/getGarageData';
    } else {
      url = environment.proxyEndpoint + '/stories/getPublicGarageData';
    }
    const body = {
      "latestTimestamp": 0
    }
    return this._httpClient.post(url, body, { headers: headers });
  }

  getStroiesForVin(vinOrFin: any, ciamId: any, pageNumber: number, pageSize: number): Observable<any>{
    let api_header = {
      headers: { 'Content-Type': 'application/json', 'vinOrFin': vinOrFin, 'ciamId': ciamId },
    };
    let url = '';
    if (localStorage.getItem('isLoggedIn') === 'true') {
      url = `${environment.proxyEndpoint}/stories/getStories?pageSize=${pageSize}&pageNumber=${pageNumber}`
    } else {
      url = `${environment.proxyEndpoint}/stories/getPublicStoriesForCar?pageSize=${pageSize}&pageNumber=${pageNumber}`
    }
    return this._httpClient.get<any>(url, api_header);
  }

  public getProfile(userId?: any): Observable<any> {
    let api_header = {};
    if (userId) {
      api_header = {
        headers: {'userId': userId}
      };
    }
    let url = '';
    if (localStorage.getItem('isLoggedIn') === 'true') {
      url = `${environment.proxyEndpoint}/stories/getUser?isStories=1`;
    } else {
      url = `${environment.proxyEndpoint}/stories/getPublicProfileData`;
    }
    return this._httpClient.get<any>(url, api_header);
  }

  public getUserInfo(eventId: string): Observable<any>{
    const baseUrl = environment.serverUrl
    const url= `${baseUrl}api/v2/customer_ciam/events/${eventId}/register`;
    return this._httpClient.get(url);
  }
  public registerUser(eventId: string): Observable<any>{
    const baseUrl = environment.serverUrl
    const url= `${baseUrl}api/v2/customer_ciam/events/${eventId}/register`;
    return this._httpClient.post(url,{});
  }

  public updateProfile(nickName: string, description: string, socialLink: string, userId: any): Observable<any> {
    const api_header = { 'Content-Type': 'application/json', 'userId': userId};
    const baseUrl= environment.proxyEndpoint +'/stories/updateUser?isStories=1';
    const url=`${baseUrl}`;
    return this._httpClient.put(url,{nickName, description, socialLink},{headers: api_header});
  }
  /**
   * @description called post successful CIAM login; will have customer details and
   * event details. Called when we reach the link-participant page
   * @param participantId
   * @param participantKey
   * @returns Participant details and event details
   */
  public getParticipantInfo(participantId: any, participantKey: any): Observable<any>{
    const baseUrl = environment.serverUrl
    const url= `${baseUrl}api/v2/customer_ciam/participant/${participantId}?participantSecretKey=${participantKey}`;
    return this._httpClient.get(url);
  }

  /**
   * @description called on confirm click and refresh
   * @param participantId
   * @param participantKey
   * @returns event data
   */
  public updateCiamConfirmation(participantId: any, participantKey:any): Observable<any> {
    // const baseUrl= environment.serverUrl;
    const baseUrl = environment.serverUrl;
    const url = `${baseUrl}api/v2/customer_ciam/participant/${participantId}?participantSecretKey=${participantKey}`;
    return this._httpClient.put(url,{});
  }

  public isValidGuID(guID: any){
    const regex = /^[{]?[0-9a-fA-F]{8}-([0-9a-fA-F]{4}-){3}[0-9a-fA-F]{12}[}]?$/
    return regex.test(guID)
  }


}
